export default "__VITE_ASSET__CjtUMxqq__"